import React, { useContext, useState, useEffect } from 'react';
import Navbar from '../../../components/DesktopNavbar';
import { mainMenu } from '../../../config/dropoffMenu.jsx';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../../context/UserProvider';
import { list } from '../../../services/manifest';
import { moneyFormat, toTitleCase } from '../../../utils/helpers';
import { isMobile } from 'react-device-detect';
import { Button } from '@mui/material';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

const App = () => {
  const navigate = useNavigate();
  const { token } = useContext(UserContext);
  const [refNumber, setRefNumber] = useState('');


  const handleNextManifest = () => {
    if (!refNumber) {
      alert('Please enter a manifest ferefence number');
      return;
    }

    const payload = {
        'fields': {
            'reference-id': refNumber,
        },
        'record-per-page': 'all',
        'operator': '=',
        'user-specific': false,
    };

    list(token, payload).then(response => {
        if (response['data-total'] === 0) {
            alert('No manifest found with the reference number');
            return;
        }

        const manifest = response.collection[0];
        
        if (manifest.data.status !== 'ready for transfer') {
            alert('Manifest is not ready for transfer');
            return;
        }
        
        navigate(`/dropoff/manifest/${manifest.raw.id}/accept`);
    });
  };

  return (
    <>
      <Navbar pages={mainMenu} />
      <Container maxWidth={'xl'}>
        <Grid container spacing={2} style={{ height: 'auto' }}>
          <Grid item xs={12} sm={6} style={{ height: '100px' }}>
            <h1>Accept Manifest</h1>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            style={
              isMobile
                ? { height: '100px' }
                : { height: '100px', paddingTop: '40px' }
            }>
            <Button
              variant="contained"
              onClick={() => handleNextManifest()}
              style={
                isMobile
                  ? {}
                  : {
                      width: '160px',
                      float: 'right',
                    }
              }>
              Next
            </Button>
            <Button
              variant="contained"
              onClick={() => navigate('/dropoff/received')}
              style={
                isMobile
                  ? {}
                  : {
                      width: '160px',
                      float: 'right',
                      marginRight: '10px',
                    }
              }>
              Back
            </Button>
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              label={'Manifest Reference Number'}
              variant="outlined"
              type={'text'}
              onChange={e => {
                setRefNumber(e.target.value);
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default App;
